import React from 'react'
import { Table, Button, Form, Alert, Row } from 'react-bootstrap'
import './DocumentUpload.css'
import { InfoCircle } from 'react-bootstrap-icons'

const documentUpload = (props) => {

    var table = [];
    var tempFiles = [];
    var files = [];

    if (props.selectedFiles.length > 0) {
        table = (
            <Table striped bordered hover>
                <caption style={{ "display": "none" }}>Učitani dokumenti</caption>
                <thead className="col-12">
                    <tr>
                        <th colspan="2">Učitani dokumenti</th>
                    </tr>
                </thead>
                <tbody>
                    {files}
                </tbody>
            </Table>
        );
        for (var i = 0; i < props.selectedFiles.length; i++) {
            tempFiles.push(props.selectedFiles[i]);
        }

        tempFiles.map((file, index) =>
            files.push(<tr key={index}>
                <td className="col-10">{file.name}</td>
                <td className="col-2 actions"><Button onClick={e => { props.handleDelete(e, index) }}>Ukloni</Button></td>
            </tr>));
    }

    const handleClick = (e) => {
        e.target.value = '';
    }

    return (
        <>
            <Form.Group>

                <div className="step-label">02</div>

                {props.showAdditionalField === 1 ?
                    <h4>Predaja dokumentacije ili unos teksta zahtjeva</h4>
                    :
                    props.showAdditionalField === 3 ? <h4>Predaja dokumentacije</h4> : <h4>Predaja dokumentacije</h4>
                }
                {
                    props.showAlert ?
                        (<div className="doc-msg"><Alert variant="danger">
                            {props.alertMsg}
                        </Alert></div>) :
                        null
                }
                <Form.Label>Ovdje učitajte prethodno preuzete i popunjene obrasce i/ili druge potrebne dokumente.               </Form.Label>
                <div className="custom-file">
                    <input type="file" accept="application/pdf" multiple
                        required={props.requiredField} className="custom-file-input" id="inputGroupFile04" onChange={props.handleFile} onClick={handleClick} />
                    <label className="custom-file-label" htmlFor="inputGroupFile04" data-browse="Učitajte" >Učitajte dokumentaciju za predaju</label>
                    <Form.Control.Feedback type="invalid">Potrebno je odabrati dokumentaciju za predaju.</Form.Control.Feedback>
                </div>

                <Row style={{ margin: "0px", paddingLeft: "15px", paddingRight: "15px", paddingTop: "15px" }}>
                    <InfoCircle size={24} color={"#0062E0"} style={{ marginRight: "0.2em" }} /> <p>Kako pravilno elektronički potpisati dokument certifikatom na Fina kriptouređaju, provjerite <a className="cardLink" href="https://www.fina.hr/ngsite/content/download/15930/250145/1" target="_blank" rel="noopener noreferrer">ovdje</a>.</p>
                </Row>

            </Form.Group>

            {table}
        </>
    )
}

export default documentUpload
